"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTrashCanOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M28 5h-7v-.75a3.8 3.8 0 00-.87-2.77A5.33 5.33 0 0016 .06a5.33 5.33 0 00-4.14 1.42A3.58 3.58 0 0011 4v1H4v2h2l1 23h18l1-23h2zM13 4c0-.78.16-1 .37-1.23A3.62 3.62 0 0116 2.06a3.66 3.66 0 012.62.73c.2.24.38.44.38 1.46V5h-6zm10 24H9L8 7h16z" }),
        React.createElement("path", { d: "M12 11.06h2V24h-2zM18 11.06h2V24h-2z" })));
}
exports.default = SvgTrashCanOutline;
//# sourceMappingURL=TrashCanOutline.js.map